<template>
	<div class="language-switch">
		<button class="lang"
							@click.prevent.stop="setLocale('en')"
							:class="locale === 'en' ? 'lang--active' : ''">EN</button>
		<span class="language-switch__divider">|</span>
		<button @click.prevent.stop="setLocale('ja')"
							class="lang"
							:class="locale === 'ja' ? 'lang--active' : ''">JP</button>
	</div>
</template>

<script setup>
import { useI18n, useSwitchLocalePath } from '#imports'
const { locale, setLocale } = useI18n()
</script>

<style lang="scss">
@use '@/assets/sass/variables.scss' as v;
.language-switch {
	font-family: var(--font);
	margin: 0 1rem 0 0;
	@include v.respond-to('small') {
		margin: 0;
	}
	.lang {
		background: transparent;
		border: none;
		border-radius: 1.5rem;
		color: v.$white;
		cursor: pointer;
		font-weight: 900;
		opacity: 0.5;
		padding: 0.25rem 0;
		transition: opacity 0.3s;
		&--active {
			cursor: text;
			opacity: 1;
			transition: opacity 0.3s;
			&:hover {
				background: transparent;
			}
		}
		&:hover {
			opacity: 1;
		}
	}
	&__divider {
		margin: 0 0.5rem;
	}
}
</style>
